import React from 'react'
import { Helmet } from 'react-helmet';
import AppLayoutTitle from './appLayoutTitle';


const AppMonitoring = () => <>
    <Helmet>
        <title>Monitoring | Sparkling Email</title>
    </Helmet>
    <>
        <AppLayoutTitle title="Monitoring" />
        <div className="px-3 py-3">
            <div>
                Check real‑time health and performance of our cloud services.
            </div>
            <div>
                See uptime, response times, error rates, and current load for translation engines,
                signature processors and mail connectors. Receive alerts on any service degradation
                so you can act before your users notice.
            </div>
            <br />
            <div className="text-center my-5">
                <a
                    className="btn btn-lg btn-outline-secondary"
                    href="https://sparklingemail.statuspage.io/"
                    target="_blank"
                    rel="noreferrer"
                >View Status Page</a>
            </div>
        </div>
    </>
</>
export default AppMonitoring